import { Nullable } from "@core/domain/types/nullable.type";
import { ToastManagerStore } from "@core/presentacion/component/feedback/toast-manager/toast-manager.store";
import { BudgetRepository } from "@project/data/repositories/budget.repository";
import { EditBudgetCategoryGroup } from "@project/domain/models/budget/budget-category/groups/edit-budget-category-group.model";
import { BudgetCategoryGroup } from "@project/domain/models/budget/financial-entity-budget.model";
import { inject, injectable } from "inversify";

@injectable()
export class EditCategoryGroupUseCase {
    constructor(
        @inject(BudgetRepository)
        private readonly budgetRepository: BudgetRepository,
    ) {}
    async execute(
        group: EditBudgetCategoryGroup,
    ): Promise<Nullable<BudgetCategoryGroup>> {
        const editResult = await this.budgetRepository.editCategoryGroup(group);

        if (editResult.isLeft()) {
            ToastManagerStore.error(editResult.getLeftOrThrow().message);
        }
        return editResult.fold(
            () => null,
            (editedGroup) => editedGroup,
        );
    }
}
